export default __webpack_public_path__ + "static/media/Sweetpressed Haste.df5c3c0b.jpg";